const DY_API_URL = `${process.env.DY_API}`

export const getSearchParams = query => {
  if (!query?.searchParams || typeof query?.searchParams !== 'object') return ''
  let searchParams = '?'
  if (query.searchParams?.page) searchParams += `page=${query.searchParams.page ?? 1}`
  if (query.searchParams?.q) searchParams += `${searchParams.length > 1 ? '&' : ''}q=${query.searchParams.q}`
  if (query.searchParams?.status) searchParams += `${searchParams.length > 1 ? '&' : ''}status=${query.searchParams.status}`
  if (query.searchParams?.sort) searchParams += `${searchParams.length > 1 ? '&' : ''}sort=${query.searchParams.sort}`
  if (query.searchParams?.direction) searchParams += `${searchParams.length > 1 ? '&' : ''}direction=${query.searchParams.direction}`
  if(searchParams.length === 1) return ''
  return searchParams
}

export const endpoints = {
  'auth-login': () => `${DY_API_URL}/auth/login`,
  'auth-token-validator': (query) => `${DY_API_URL}/auth/token_validator?token_type=signup&token=${query.token}`,
  'auth-signup': (query) => `${DY_API_URL}/auth/signup?token=${query.token}`,
  'auth-admin-login': () => `${DY_API_URL}/auth/admin_login`,
  'auth-admin-signup': (query) => `${DY_API_URL}/auth/admin_signup?token=${query.token}`,
  'auth-forgot-password': () => `${DY_API_URL}/auth/forgot_password`,
  'auth-reset-password': (query) => `${DY_API_URL}/auth/reset_password?token=${query.token}`,
  'commission-validate': () => `${DY_API_URL}/commissions/validate`,
  'commissions-notify-to': (query) => `${DY_API_URL}/commissions/notify?to=${query.email}`, // TEST endpoint ONLY
  'commissions-notify': () => `${DY_API_URL}/commissions/notify`,
  'download-customers-csv': () => `${DY_API_URL}/customers/customers_summary_csv`,
  'download-vet-commission-invoice': (query) => `${DY_API_URL}/vets/${query.vet_id}/commissions/${query.commission_id}/invoice`,
  // Spite of backend endpoint says 'csv' it must download an xls file
  'download-orders-xls': () => `${DY_API_URL}/orders/order_invoice_numbers_csv`,
  'download-vet-qr': (query) => `${DY_API_URL}/vets/${query.vet_id}/download_qr`,
  'download-virbac-admin-order': (query) => `${DY_API_URL}/orders/${query.order_id}/admin_order_invoice`,
  // Products list for recommendations
  'products': () => `${DY_API_URL}/products`,
  'user-detail': (query) => `${DY_API_URL}${query?.vet_id ? `/vets/${query.vet_id}` : ''}/users/${query?.user_id ?? ''}`,
  'user-invite': (query) => `${DY_API_URL}/users/${query.user_id}/invite`,
  'users': (query) => `${DY_API_URL}${query?.vet_id ? `/vets/${query.vet_id}` : ''}/users${getSearchParams(query)}`,
  // <Select list of users
  'not-corporate-users': () => `${DY_API_URL}/users/not_corporates`,
  'corporate-users': (query) => `${DY_API_URL}/users/corporates${getSearchParams(query)}`,
  'corporate-user-detail': (query) => `${DY_API_URL}/users/corporates/${query.user_id}`,
  'corporate-my-customers': (query) => `${DY_API_URL}/users/${query.user_id}/customers${getSearchParams(query)}`,
  // Invite user (vets.length > 1) corporate to another vet
  // Resend invite of a user corporate to a vet
  // Invite a single vet (not corporate => vets.length === 1) user to a second vet
  'corporate-user-invite-to-vet': () => `${DY_API_URL}/user_vets/invite`,
  'corporate-user-delete-from-vet': (query) => `${DY_API_URL}/user_vets?user_id=${query.user_id}&vet_id=${query.vet_id}`,
  // <Select list of vets
  'corporate-vets': () => `${DY_API_URL}/vets/corporate`,
  'corporate-vets-commissions': () => `${DY_API_URL}/vets/commissions_overview`,
  'user-account': () => `${DY_API_URL}/users/show_current_user`,
  'user-account-update': () => `${DY_API_URL}/users/update_current_user`,
  'vet-commission-detail': (query) => `${DY_API_URL}/vets/${query.vet_id}/commissions/${query.commission_id}`,
  'vet-commission-orders': (query) => `${DY_API_URL}/vets/${query.vet_id}/commissions/${query.commission_id}/orders`,
  'vet-commissions': (query) => `${DY_API_URL}/vets/${query.vet_id}/commissions${getSearchParams(query)}`,
  'vet-commission-update': (query) => `${DY_API_URL}/vets/${query.vet_id}/commissions/${query.commission_id}`,
  'vet-customers': (query) => `${DY_API_URL}/vets/${query.vet_id}/customers${getSearchParams(query)}`,
  'vet-customer-detail': (query) => `${DY_API_URL}/vets/${query.vet_id}/customers/${query.customer_id}`,
  'vet-customer-delete': (query) => `${DY_API_URL}/vets/${query.vet_id}/customers/${query.customer_id}/remove_customer`,
  'vet-customer-invoices': (query) => `${DY_API_URL}/vets/${query.vet_id}/customers/${query.customer_id}/orders`,
  'vet-customer-invite': (query) => `${DY_API_URL}/vets/${query.vet_id}/send_invite`,
  'vet-customer-recommendations': (query) => `${DY_API_URL}/vets/${query.vet_id}/recommendations?customer_id=${query.customer_id}`,
  'vet-detail': (query) => `${DY_API_URL}/vets/${query.vet_id}`,
  'vet-detail-update': (query) => `${DY_API_URL}/vets/${query.vet_id}`,
  'vet-detail-status': (query) => `${DY_API_URL}/vets/${query.vet_id}/status`,
  'vet-fiscal-predecessor-candidates': (query) => `${DY_API_URL}/vets/${query.vet_id}/fiscal_predecessor_candidates`,
  'vet-users':  (query) => `${DY_API_URL}/vets/${query.vet_id}/users${getSearchParams(query)}`,
  'vet-recommendation-delete': (query) => `${DY_API_URL}/vets/${query.vet_id}/recommendations/${query.recommendation_id}`,
  'vet-recommendations': (query) => `${DY_API_URL}/vets/${query.vet_id}/recommendations${getSearchParams(query)}`,
  // 'admin' && 'zone_manager' only invite for first invite or reinvites until clinic got registered
  'vet-invite': (query) => `${DY_API_URL}/vets/${query.vet_id}/invite`,
  'vet-user-invite': (query) => `${DY_API_URL}/vets/${query.vet_id}/users/${query.user_id}/invite`,
  'vets': (query) => `${DY_API_URL}/vets${getSearchParams(query)}`,
  // ADMIN EXCLUSIVE
  'virbac-admin-get-global-orders': (query) => `${DY_API_URL}/orders/admin_orders${getSearchParams(query)}`,
  // PRINTING PDFs API ONLY
  'print-pdf-order-invoice': (query) => `${DY_API_URL}/pdf/orders/${query.order_id}/invoice`,
  'print-pdf-commission-invoice': (query) => `${DY_API_URL}/pdf/commissions/${query.commission_id}/invoice`,
  'print-pdf-vet-qr': (query) => `${DY_API_URL}/pdf/vets/${query.vet_id}/qr`,
	// VET CLINICS AVAILABLE FOR THIS ZONE_MANAGER
	'vet-clinics-available-for-zone-managers': (_query) => `${DY_API_URL}/vets/zone_manager_vets_selection`,
	// [ASSIGN/UNSASSIGN] VET CLINIC [TO/FROM] ZONE_MANAGER
	'assign-vet-clinic-to-zone-manager': (_query) => `${DY_API_URL}/user_vets/assign`,
	'unassign-vet-clinic-from-zone-manager': (_query) => `${DY_API_URL}/user_vets/unassign`,
}

